import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "variant"]
const _hoisted_2 = { class: "btn_content" }

import {
    ref,
    watch,
    nextTick,
    PropType,
    ComputedRef,
    computed,
    CSSProperties,
  } from 'vue';
  import SpinnerComponent from './SpinnerComponent.vue';

  enum SpinnerColor {
    Black = 'var(--black-color)',
    White = 'var(--white-color)',
    Purple = 'var(--purple-color)',
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    enable: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String as PropType<
        'default' | 'primary' | 'secondary' | 'yellow' | 'bordered' | 'icon'
      >,
      default: 'default',
    },
    height: {
      type: String,
      default: null,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onClick'],
  setup(__props, { expose, emit }) {

const props = __props

  

  const cursorPos = ref<object>({});
  const animate = ref<boolean>(false);
  const ripple = ref<{
    left: number;
    top: number;
    width: number;
    height: number;
  }>({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  const loaderColor = computed(() => {
    switch (props.variant) {
      case 'primary':
        return SpinnerColor.White;
      case 'yellow':
        return SpinnerColor.Black;

      default:
        return 'currentColor';
    }
  });

  const styles: ComputedRef<CSSProperties> = computed(() => {
    let _styles: CSSProperties = {};
    if (props.height) {
      _styles.height = props.height;
    }
    if (props.fullWidth) {
      _styles.width = '100%';
    }
    return _styles;
  });

  watch(cursorPos, (val, oldVal) => {
    if (animate.value) {
      animate.value = false;
      nextTick(() => {
        reppling(val);
      });
    } else {
      reppling(val);
    }
  });
  

  const handleClick = (e: MouseEvent) => {
    cursorPos.value = {
      top: e.clientY,
      left: e.clientX,
    };
    if (props.enable) {
      emit('onClick', e);
    }
  };

  const buttonRef = ref<HTMLButtonElement | null>(null);

  const reppling = cursorPos => {
    const $button = buttonRef.value;
    if (!$button) {
      return;
    }
    const buttonPos = $button.getBoundingClientRect();
    const buttonWidth = $button.offsetWidth;
    const buttonHeight = $button.offsetHeight;
    const rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth);
    const centerize = rippleWidthShouldBe / 2;
    animate.value = true;
    ripple.value = {
      width: rippleWidthShouldBe,
      height: rippleWidthShouldBe,
      top: cursorPos.top - buttonPos.top - centerize,
      left: cursorPos.left - buttonPos.left - centerize,
    };
  };

  expose({
    buttonRef,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn medium border-radius", [{ disabled: !__props.enable }, { loading: __props.isLoading }]]),
    ref_key: "buttonRef",
    ref: buttonRef,
    onClick: handleClick,
    disabled: !__props.enable,
    variant: __props.variant,
    style: _normalizeStyle(_unref(styles))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass('ripple ' + (animate.value ? 'active' : '')),
      style: _normalizeStyle({
        top: ripple.value.top + 'px',
        left: ripple.value.left + 'px',
        width: ripple.value.width + 'px',
        height: ripple.value.height + 'px',
      })
    }, null, 6),
    (__props.isLoading)
      ? (_openBlock(), _createBlock(SpinnerComponent, {
          key: 0,
          color: _unref(loaderColor)
        }, null, 8, ["color"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 14, _hoisted_1))
}
}

})